module.exports = __webpack_public_path__ + "img/web_top_pic_english.dc5cb1bd.png";